import percentChanged from "../../../../components/percentChanged/percentChanged";
import { connect } from "react-redux";

export default connect((state) => ({
  changeValue: state.membershipDraft.membershipDraft.recurring?.prevRecurringRevenueMTD.change,
  toolTip:
    state.membershipDraft.membershipDraft.recurring?.prevRecurringRevenueMTD.tooltip ||
    "Percentage change from previous month",
  showBorder: true
}))(percentChanged);
